$(document).ready(function () {
  let items = [...document.querySelectorAll(".gallery-section .item")];
  let closeGalleryBtns = [...document.querySelectorAll(".close-gallery-btn")];

  $(".gallery").owlCarousel({
    loop: true,
    dots: false,
    items: 2,
    nav: false,
    center: true,
    responsive: {
      560: {
        items: 4,
      },
      768: {
        center: false,
        items: 5,
        nav: true,
      },
    },
  });

  $(".popup-gallery").owlCarousel({
    loop: true,
    dots: false,
    items: 1,
    nav: true,
  });

  function openImage(num) {
    $("#gallery-carousel").trigger("to.owl.carousel", num);
    document.querySelector(".location .title").classList.add("popup");
    document.querySelector(".location .stores").style.display = "none";
    document.querySelector(".gallery-section").style.display = "none";
    document.querySelector(".gallery-popup").style.display = "block";
  }

  items.forEach((item, index) => {
    item.addEventListener("click", function () {
      openImage(index);
    });
  });

  closeGalleryBtns.map((closeGalleryBtn) => {
    closeGalleryBtn.addEventListener("click", function () {
      document.querySelector(".gallery-popup").style.display = "none";
      document.querySelector(".gallery-section").style.display = "block";
      document.querySelector(".location .stores").style.display = "block";
      document.querySelector(".location .title").classList.remove("popup");
    });
  });
});
